import { useAppStore } from '../../state/appStore';
import { THEORY_MANUAL_SECTIONS, THEORY_SECTIONS } from '../../i18n/theory';
import { useT } from '../hooks';
import { BigButton, Panel, ScreenShell } from '../components';

function SectionGrid({ keys, accent }: { keys: readonly string[]; accent: string }) {
  const t = useT();
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {keys.map((k, i) => (
        <Panel key={k} className="px-5 py-4">
          <div className={`font-semibold ${accent}`}>
            {i + 1}. {t(`${k}.title`)}
          </div>
          <p className="mt-1 text-sm leading-relaxed text-white/70">{t(`${k}.body`)}</p>
        </Panel>
      ))}
    </div>
  );
}

export function TheoryScreen() {
  const t = useT();
  const setScreen = useAppStore((s) => s.setScreen);
  return (
    <ScreenShell>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="min-w-0 flex-1 break-words text-2xl font-bold sm:text-3xl">{t('theory.title')}</h2>
        <BigButton className="shrink-0" variant="ghost" onClick={() => setScreen('menu')}>
          ← {t('settings.back')}
        </BigButton>
      </div>
      <p className="text-white/70">{t('theory.intro')}</p>

      <h3 className="mt-2 text-xl font-bold text-amber-300">🦵 {t('theory.manualBlock')}</h3>
      <SectionGrid keys={THEORY_MANUAL_SECTIONS} accent="text-amber-300" />

      <h3 className="mt-2 text-xl font-bold text-sky-300">🚗 {t('theory.commonBlock')}</h3>
      <SectionGrid keys={THEORY_SECTIONS} accent="text-sky-300" />
    </ScreenShell>
  );
}
